import { motion } from "framer-motion";
import {
  industriesWeEmpower,
  investInProfessionalService,
  keyPerformanceIndicators,
} from "./data.js";
import BoxLayout from "./component/BoxLayout/BoxLayout.jsx";

export const IndustriesWeEmpower = () => {
  return (
    <>
      <section className="container space-y-14 ">
        <div className="space-y-5 mx-auto md:w-11/12 lg:w-10/12 xl:w-8/12   ">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
         className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  font-bold text-dark font-butler"
          >
            Industries We Empower{" "} 
          </motion.h2>
          <p className="text-base leading-[1.625rem] text-center text-dark ">
            The competitive nature of SEO means every industry needs specialized
            expertise. We deliver hyper-focused SEO solutions for every
            business.
          </p>
        </div>

        <div className="flex flex-wrap  gap-x-6 gap-y-8 justify-center">
          {industriesWeEmpower.map((list, index) => {
            return (
              <BoxLayout
                key={index}
                index={index}
                icon={list.icon}
                heading={list.heading}
                text={list.text}
                colorScheme={["#erer", "#df"]}
              />
            );
          })}
        </div>
      </section>
      <section className="container space-y-14 ">
        <div className="space-y-5 mx-auto md:w-11/12 lg:w-10/12 xl:w-8/12   ">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  md:text-5xl font-bold text-dark font-butler"
          >
            Why Invest in Professional SEO Services?{" "}
          </motion.h2>
        </div>

        {/* <div className="grid  md:grid-cols-2  xl:grid-cols-3 gap-x-6 gap-y-8   place-items-center justify-items-center justify-center mx-auto"> */}
        <div className="flex flex-wrap  gap-x-6 gap-y-8 justify-center ">
          {investInProfessionalService.map((list, index) => {
            return (
              <BoxLayout
                key={index}
                index={index}
                icon={list.icon}
                heading={list.heading}
                text={list.text}
                colorScheme={["#f3ebfa", "#DF73FF"]}
              />
            );
          })}
        </div>
      </section>
      <section className="container space-y-14 ">
        <div className="space-y-5 mx-auto md:w-11/12 lg:w-10/12 xl:w-8/12   ">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  md:text-5xl font-bold text-dark font-butler"
          >
            Key Performance Indicators (KPIs) We Track{" "}
          </motion.h2>
          <p className="text-base leading-[1.625rem] text-center text-dark">
            We prioritize metrics that directly impact your business success,
            ensuring full accountability and transparency.
          </p>
        </div>

        <div className="flex flex-wrap  gap-x-6 gap-y-8 justify-center ">
          {" "}
          {keyPerformanceIndicators.map((list, index) => {
            return (
              <BoxLayout
                key={index}
                index={index}
                icon={list.icon}
                heading={list.heading}
                text={list.text}
                colorScheme={["#erer", "#df"]}
              />
            );
          })}
        </div>
      </section>
    </>
  );
};
